'use es6';

import Storage from '../util/Storage';
const QA_DOT_COM = 'qa.com';
let storage;
try {
  const localStorage = window && window.localStorage ? window.localStorage : false;
  storage = new Storage(localStorage);
} catch (e) {
  storage = new Storage(false);
}
export function isQa() {
  if (storage.getItem('ENV') === 'qa') {
    return true;
  }
  return document.domain.indexOf(QA_DOT_COM) >= 0;
}